import type { UseFormReturn } from "react-hook-form";
import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage, TextInput } from "@/components/ui";
import { RepairIntakeRadioField } from "@/pages/public/repairIntakeForm/RepairIntakeRadioField";
import type { RepairIntakeFormData } from "@/store/useRepairIntakeStore";

type RepairIntakeSection2Props = {
  form: UseFormReturn<RepairIntakeFormData>;
  utReadingsAttached: RepairIntakeFormData["section2"]["utReadingsAttached"];
};

export function RepairIntakeSection2({ form, utReadingsAttached }: RepairIntakeSection2Props) {
  return (
    <>
      <RepairIntakeRadioField form={form} name="section2.utReadingsAttached" label="1. Are UT readings Attached? *" />

      <FormField
        control={form.control}
        name="section2.utThickness"
        render={({ field }) => (
          <FormItem>
            <FormLabel>2. UT Thickness if given *</FormLabel>
            <FormControl>
              <TextInput {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      {utReadingsAttached === "No" ? (
        <FormField
          control={form.control}
          name="section2.deepestCorrosionDepth"
          render={({ field }) => (
            <FormItem>
              <FormLabel>
                3. If No To Before Question, What is the deepest measured corrosion depth in inches? *
              </FormLabel>
              <FormControl>
                <TextInput {...field} />
              </FormControl>
              <FormDescription>Corrosion depth is measured by technician on deepest corrosion pitting</FormDescription>
              <FormMessage />
            </FormItem>
          )}
        />
      ) : null}
    </>
  );
}
